<div class="form form--drivers-license form--full-width" [ngClass]="getLevelClass()">
  <basic-label></basic-label>
  <div class="form__inline-field-container">
    <div class="form__field">
      <basic-text-input
        [propertyName]="questionItem.prop + '.idNumber'"
        [disableConditionally]="noDriversLicense.inputText"
        [isDriversLicense]="true"
        [placeholder]="getPlaceholder(0) || 'License Number'"
        #licenseNumber
        (focusin)="showLicenseNumber()"
        (focusout)="obfuscateLicenseNumber()"
      ></basic-text-input>
    </div>
    <div class="form__field">
      <text-autocomplete-dropdown
        [propertyName]="questionItem.prop + '.idState'"
        [placeholder]="getPlaceholder(1) || 'State'"
        [disableConditionally]="noDriversLicense.inputText"
        #licenseState
      ></text-autocomplete-dropdown>
    </div>
    <div
      class="form__field"
      [class.entry-field--disabled]="licenseExpirationDate.isDisabled || licenseExpirationDate.disableConditionally"
      [class.entry-field--error]="!!errorMessage[prop]"
    >
      <div class="input-label-container">
        <label
          class="entry-field__label"
          for="{{ licenseExpirationDate.componentId }}"
          [class.entry-field--error__label]="!!errorMessage[prop]"
          [class.entry-field--filled__label]="!errorMessage[prop] && !!licenseExpirationDate.val"
        >
          {{ getPlaceholder(2) || 'Expiration Date' }}
        </label>
        <basic-text-input
          id="{{ licenseExpirationDate.componentId }}"
          [parserType]="'Date'"
          [propertyName]="questionItem.prop + '.idExpires'"
          [placeholder]="'mm/dd/yyyy'"
          [hideLabel]="true"
          [formatterType]="'date_mmddyyyy'"
          (change)="trigger()"
          [disableConditionally]="noDriversLicense.inputText"
          [isDriversLicense]="true"
          [inputMask]="mask"
          #licenseExpirationDate
        ></basic-text-input>
      </div>
    </div>
  </div>
  <div>
    <basic-checkbox
      id="hasNoDriversLicense"
      (change)="trigger()"
      labelText="{{ is2020CoverpathOrMMD ? 'No Driver\'s License' : 'I don\'t have a Driver\'s License' }}"
      [propertyName]="questionItem.prop + '.hasNoDriversLicense'"
      [skipModelUpdate]="true"
      #noDriversLicense
    ></basic-checkbox>
  </div>
</div>
